export default "__VITE_ASSET__OlX_hl8c__"